export const DsBadgeDefaultProps = {
    color: 'secondary',
    showZero: true
};
